import { Analytics } from '@cobliteam/analytics';
import { Location } from '@cobliteam/common-types';
import { withPermissions } from '@cobliteam/permissions';
import type React from 'react';
import { useEffect } from 'react';
import type { RouteComponentProps } from 'react-router';
import { useHistory } from 'react-router-dom';

// This component is now a redirect to the new report system
const Reports: React.FC<RouteComponentProps> = ({ location }) => {
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const reportType = params.get('type');

    // Track the page view
    Analytics.track('Reports Viewed');

    // Redirect based on report type
    if (reportType) {
      switch (reportType) {
        case 'outJourney':
          history.replace(Location.REPORTS_OUT_JOURNEY);
          break;
        case 'routesPoints':
          history.replace(Location.REPORTS_ROUTES_POINTS);
          break;
        case 'productivity':
          history.replace(Location.REPORTS_PRODUCTIVITY);
          break;
        case 'distanceDriven':
          history.replace(Location.REPORTS_DISTANCE_DRIVEN);
          break;
        case 'idleEngine':
          history.replace(Location.REPORTS_IDLE_ENGINE);
          break;
        case 'geofenceEvents':
          history.replace(Location.REPORTS_GEOFENCE_EVENTS);
          break;
        case 'incident':
          history.replace(Location.REPORTS_INCIDENT);
          break;
        case 'driverVehicleAssociation':
          history.replace(Location.REPORTS_DRIVER_VEHICLE_ASSOCIATION);
          break;
        default:
          // Default to the new reports home page
          history.replace(Location.REPORTS_NEW);
      }
    } else {
      // If no report type, redirect to the new home page
      history.replace(Location.REPORTS_NEW);
    }
  }, [history, location.search]);

  // Return null as this is just a redirect component
  return null;
};

export { Reports };
export default withPermissions({ Component: Reports, permissions: 'view:analytics-and-reports' });
